import { createSlice } from '@reduxjs/toolkit';

const initalTaskAccomplishmentInfo = {
  // lastTimeRange: '',
  // rangesAndResults: [],
  firstDate: '',
  lastDate: '',
};

const initalTopReferrersInfo = {
  /*
  lastTimeRange: '',
  rangesAndResults: [
    {
      timeRange: 'Last 30 days',
      cacheTime: <Date.now()>,
      results: [],
    }, ...
  ],
  */
  firstDate: '',
  lastDate: '',
  maxNToShow: 5,
};

const initialState = {
  taskAccomplishmentInfo: initalTaskAccomplishmentInfo,
  topReferrersInfo: initalTopReferrersInfo,
};

export const dashboardStatsSlice = createSlice({
  name: 'dashboardStats',
  initialState: initialState,
  reducers: {
    clearDashboardStats: () => {
      return initialState;
    },

    /*
    addTaskAccomplishmentInfo: (state, action) => {
      const { timeRange, results } = action.payload;
      const cacheTime = Date.now();
      const filtered = state.taskAccomplishmentInfo.rangesAndResults.filter((rnr) => rnr.timeRange !== timeRange);
      const newList = [...filtered, { timeRange, cacheTime, results }];
      return { ...state, taskAccomplishmentInfo: { lastTimeRange: timeRange, rangesAndResults: newList } };
    },
    */

    setTaskAccomplishmentDateRange: (state, action) => {
      const { firstDate, lastDate } = action.payload; // These are ISO strings
      const oldInfo = state.taskAccomplishmentInfo;
      const newInfo = { ...oldInfo, firstDate, lastDate };
      return { ...state, taskAccomplishmentInfo: newInfo };
    },

    clearTaskAccomplishmentInfo: (state) => {
      return { ...state, taskAccomplishmentInfo: initalTaskAccomplishmentInfo };
    },

    /*
    addTopReferrersInfo: (state, action) => {
      const { timeRange, maxNToShow, results } = action.payload;
      const cacheTime = Date.now();
      const filtered = state.topReferrersInfo.rangesAndResults.filter(
        (rnr) => rnr.timeRange !== timeRange || rnr.maxNToShow !== maxNToShow
      );
      const newList = [...filtered, { timeRange, maxNToShow, cacheTime, results }];
      return {
        ...state,
        topReferrersInfo: { lastTimeRange: timeRange, lastMaxNToShow: maxNToShow, rangesAndResults: newList },
      };
    },
    */

    setTopReferrersInfo: (state, action) => {
      const { firstDate, lastDate, maxNToShow } = action.payload; // These are ISO strings
      const oldInfo = state.topReferrersInfo;
      const newInfo = { ...oldInfo, firstDate, lastDate, maxNToShow };
      return { ...state, topReferrersInfo: newInfo };
    },

    clearTopReferrersInfo: (state) => {
      return { ...state, topReferrersInfo: initalTopReferrersInfo };
    },
  },
});

export const {
  clearDashboardStats,
  setTaskAccomplishmentDateRange,
  clearTaskAccomplishmentInfo,
  setTopReferrersInfo,
  clearTopReferrersInfo,
} = dashboardStatsSlice.actions;

export default dashboardStatsSlice.reducer;
